import React from 'react'

/*
 * Home page icon set. Inline SVG so HomeContent.scss drives the motion
 * and can stop it under reduced motion. Shared geometry: 40x40 box,
 * 2.2px round strokes, artwork inside 4-36, one animated accent each.
 */

const Svg = ({ children }) => (
  <svg className="ic" viewBox="0 0 40 40" aria-hidden="true" focusable="false">{children}</svg>
);

/* --- modules --- */

export const IconReport = () => (
  <Svg>
    <rect className="ic-soft" x="7" y="4" width="26" height="32" rx="6" />
    <rect x="7" y="4" width="26" height="32" rx="6" />
    <rect className="ic-fill ic-bar ic-bar-1" x="13"   y="22" width="4" height="8"  rx="2" />
    <rect className="ic-fill ic-bar ic-bar-2" x="18.5" y="18" width="4" height="12" rx="2" />
    <rect className="ic-fill ic-bar ic-bar-3" x="24"   y="14" width="4" height="16" rx="2" />
  </Svg>
);

export const IconClock = () => (
  <Svg>
    <circle className="ic-soft" cx="20" cy="20" r="15" />
    <circle cx="20" cy="20" r="15" />
    <path className="ic-accent" d="M20 20 h6" />
    <path className="ic-hand" d="M20 20 V10" />
    <circle className="ic-fill" cx="20" cy="20" r="2" />
  </Svg>
);

export const IconLeave = () => (
  <Svg>
    <rect className="ic-soft" x="4" y="7" width="32" height="29" rx="6" />
    <rect x="4" y="7" width="32" height="29" rx="6" />
    <path d="M4 16 h32 M12 3 v8 M28 3 v8" />
    <path className="ic-accent ic-draw" d="M13.5 25.5 L18 30 L27 21" />
  </Svg>
);

export const IconBoard = () => (
  <Svg>
    <rect className="ic-soft" x="4" y="7" width="32" height="26" rx="5" />
    <rect x="4"    y="7" width="9.6" height="26" rx="4" />
    <rect x="15.2" y="7" width="9.6" height="26" rx="4" />
    <rect x="26.4" y="7" width="9.6" height="26" rx="4" />
    <rect className="ic-fill ic-travel" x="6.2" y="11" width="5.2" height="4.4" rx="2" />
  </Svg>
);

export const IconHire = () => (
  <Svg>
    <circle className="ic-soft" cx="16" cy="13" r="7" />
    <circle cx="16" cy="13" r="6.4" />
    <path d="M4.5 33 a11.5 11.5 0 0 1 21 -6" />
    <g className="ic-lens">
      <circle className="ic-accent" cx="27.5" cy="26" r="6.6" />
      <path className="ic-accent" d="M32.3 30.8 L36 34.5" />
    </g>
  </Svg>
);

export const IconAsset = () => (
  <Svg>
    <rect className="ic-soft" x="7" y="6" width="26" height="19" rx="4" />
    <rect x="7" y="6" width="26" height="19" rx="4" />
    <path d="M3.5 30 h33 l-2.8 4 H6.3 Z" />
    <circle className="ic-fill ic-pulse" cx="20" cy="15.5" r="3.6" />
  </Svg>
);

/* --- reports --- */

export const IconStack = () => (
  <Svg>
    <path className="ic-soft ic-layer ic-layer-1" d="M20 3 L35 10.5 L20 18 L5 10.5 Z" />
    <path className="ic-layer ic-layer-1" d="M20 3 L35 10.5 L20 18 L5 10.5 Z" />
    <path className="ic-accent ic-layer ic-layer-2" d="M5 19 L20 26.5 L35 19" />
    <path className="ic-accent ic-layer ic-layer-3" d="M5 27 L20 34.5 L35 27" />
  </Svg>
);

export const IconTeam = () => (
  <Svg>
    <circle className="ic-soft" cx="14" cy="13" r="7" />
    <circle cx="14" cy="13" r="6.4" />
    <path d="M3.5 33 a10.5 10.5 0 0 1 21 0" />
    <circle className="ic-accent ic-pop" cx="29.5" cy="16" r="5" />
    <path className="ic-accent ic-pop" d="M23 33 a6.5 6.5 0 0 1 13 0" />
  </Svg>
);

export const IconDonut = () => (
  <Svg>
    <circle className="ic-soft" cx="20" cy="20" r="14" />
    <circle cx="20" cy="20" r="13.5" />
    <circle className="ic-accent ic-arc" cx="20" cy="20" r="13.5" transform="rotate(-90 20 20)" />
    <circle className="ic-fill" cx="20" cy="20" r="3.2" />
  </Svg>
);

/* --- reasons --- */

export const IconShield = () => (
  <Svg>
    <path className="ic-soft" d="M20 3 L34 8 v12 c0 8.4 -5.8 14.4 -14 17 -8.2 -2.6 -14 -8.6 -14 -17 V8 Z" />
    <path d="M20 3 L34 8 v12 c0 8.4 -5.8 14.4 -14 17 -8.2 -2.6 -14 -8.6 -14 -17 V8 Z" />
    <path className="ic-accent ic-draw" d="M14 20 L18.4 24.4 L26.5 15.5" />
  </Svg>
);

export const IconDevices = () => (
  <Svg>
    <rect className="ic-soft" x="3" y="7" width="24" height="18" rx="4" />
    <rect x="3" y="7" width="24" height="18" rx="4" />
    <path d="M9 30 h13" />
    <rect className="ic-accent ic-rise" x="24" y="18" width="13" height="19" rx="4" />
    <path className="ic-accent ic-rise" d="M28.5 33.5 h4" />
  </Svg>
);

export const IconBolt = () => (
  <Svg>
    <circle className="ic-soft" cx="20" cy="20" r="15" />
    <circle cx="20" cy="20" r="15" />
    <path className="ic-fill ic-flash" d="M21.6 8 L13 21.4 h5.6 L17.6 32 L27 18.2 h-5.8 Z" />
  </Svg>
);

export const IconExport = () => (
  <Svg>
    <path className="ic-soft" d="M5 22 v8 a4 4 0 0 0 4 4 h22 a4 4 0 0 0 4 -4 v-8" />
    <path d="M5 22 v8 a4 4 0 0 0 4 4 h22 a4 4 0 0 0 4 -4 v-8" />
    <path className="ic-accent ic-lift" d="M20 26 V5 M12.5 12.5 L20 5 L27.5 12.5" />
  </Svg>
);

/* --- modules added to match the app's sidebar --- */

export const IconGauge = () => (
  <Svg>
    <path className="ic-soft" d="M6 29 a14 14 0 0 1 28 0 Z" />
    <path d="M6 29 a14 14 0 0 1 28 0" />
    <path className="ic-accent ic-needle" d="M20 29 L13.5 19.5" />
    <circle className="ic-fill" cx="20" cy="29" r="2.6" />
  </Svg>
);

export const IconHelp = () => (
  <Svg>
    <path className="ic-soft" d="M8 24 v-4 a12 12 0 0 1 24 0 v4 Z" />
    <path d="M8 24 v-4 a12 12 0 0 1 24 0 v4" />
    <rect x="4" y="21" width="7.5" height="11" rx="3.5" />
    <rect className="ic-accent ic-pulse" x="28.5" y="21" width="7.5" height="11" rx="3.5" />
    <path className="ic-accent" d="M32.2 32 v1 a2.5 2.5 0 0 1 -2.5 2.5 H24" />
  </Svg>
);

export const IconChat = () => (
  <Svg>
    <path className="ic-soft" d="M8 6 h24 a5 5 0 0 1 5 5 v13 a5 5 0 0 1 -5 5 H19 l-8 6.5 V29 H8 a5 5 0 0 1 -5 -5 V11 a5 5 0 0 1 5 -5 Z" />
    <path d="M8 6 h24 a5 5 0 0 1 5 5 v13 a5 5 0 0 1 -5 5 H19 l-8 6.5 V29 H8 a5 5 0 0 1 -5 -5 V11 a5 5 0 0 1 5 -5 Z" />
    <circle className="ic-fill ic-pop" cx="13" cy="17.5" r="2.3" />
    <circle className="ic-fill ic-pop ic-d2" cx="20" cy="17.5" r="2.3" />
    <circle className="ic-fill ic-pop ic-d3" cx="27" cy="17.5" r="2.3" />
  </Svg>
);

export const IconApprove = () => (
  <Svg>
    <rect className="ic-soft" x="5" y="5" width="30" height="30" rx="11" />
    <rect x="5" y="5" width="30" height="30" rx="11" />
    <path className="ic-accent ic-draw" d="M13 20 L18 25 L27.5 14.5" />
  </Svg>
);

export const IconOrg = () => (
  <Svg>
    <rect className="ic-soft" x="14" y="3" width="12" height="9" rx="3" />
    <rect x="14" y="3" width="12" height="9" rx="3" />
    <path d="M20 12 v5 M9.5 22 v-5 h21 v5" />
    <rect className="ic-accent ic-pop" x="3.5" y="22" width="12" height="9" rx="3" />
    <rect className="ic-accent ic-pop ic-d2" x="24.5" y="22" width="12" height="9" rx="3" />
  </Svg>
);

export const IconEmployees = () => (
  <Svg>
    <rect className="ic-soft" x="7" y="6" width="26" height="30" rx="6" />
    <rect x="7" y="6" width="26" height="30" rx="6" />
    <rect x="16" y="3" width="8" height="6" rx="2" />
    <circle className="ic-accent ic-pop" cx="20" cy="19" r="4.4" />
    <path className="ic-accent ic-pop ic-d2" d="M13.5 30.5 a6.5 6.5 0 0 1 13 0" />
  </Svg>
);

export const IconBriefcase = () => (
  <Svg>
    <rect className="ic-soft" x="4" y="12" width="32" height="21" rx="5" />
    <rect x="4" y="12" width="32" height="21" rx="5" />
    <path d="M14 12 V9 a3 3 0 0 1 3 -3 h6 a3 3 0 0 1 3 3 v3" />
    <rect className="ic-fill ic-pulse" x="16" y="19" width="8" height="6" rx="2.5" />
  </Svg>
);

/* --- Attendance, Performance and Interview Schedules --- */

export const IconAttendance = () => (
  <Svg>
    <path className="ic-soft" d="M20 36 s11 -10.2 11 -18.5 a11 11 0 0 0 -22 0 C9 25.8 20 36 20 36 Z" />
    <path d="M20 36 s11 -10.2 11 -18.5 a11 11 0 0 0 -22 0 C9 25.8 20 36 20 36 Z" />
    <path className="ic-accent ic-draw" d="M15 17.5 L18.6 21 L25.5 14" />
  </Svg>
);

export const IconStar = () => (
  <Svg>
    <path className="ic-soft" d="M20 4.5 l4.6 9.4 10.4 1.5 -7.5 7.3 1.8 10.3 -9.3 -4.9 -9.3 4.9 1.8 -10.3 -7.5 -7.3 10.4 -1.5 Z" />
    <path d="M20 4.5 l4.6 9.4 10.4 1.5 -7.5 7.3 1.8 10.3 -9.3 -4.9 -9.3 4.9 1.8 -10.3 -7.5 -7.3 10.4 -1.5 Z" />
    <circle className="ic-fill ic-pulse" cx="20" cy="20" r="3.4" />
  </Svg>
);

export const IconInterview = () => (
  <Svg>
    <rect className="ic-soft" x="4" y="7" width="32" height="29" rx="6" />
    <rect x="4" y="7" width="32" height="29" rx="6" />
    <path d="M4 16 h32 M12 3 v8 M28 3 v8" />
    <circle className="ic-accent ic-pop" cx="20" cy="23" r="3.6" />
    <path className="ic-accent ic-pop ic-d2" d="M13.5 33 a6.5 6.5 0 0 1 13 0" />
  </Svg>
);
